import type { ColumnDef } from '@tanstack/vue-table'
import { createBaseColumns, type UserTableActions } from './baseColumns'
import { createDateColumn } from './dateColumns'
import BaseButton from '~/components/BaseButton.vue'
import ResendInvitationIcon from '~/components/ResendInvitationIcon.vue'
import TrashGreenIcon from '~/components/TrashGreenIcon.vue'

export const createPendingUsersColumns = (
  actions?: UserTableActions,
): ColumnDef<ManageUserTableRow>[] => {
  const baseColumns = createBaseColumns()
  const dateColumns = [
    createDateColumn('invitation_created_at', 'invitation_created_at', 'invitation date'),
    createDateColumn('invitation_expired_at', 'invitation_expired_at', 'expiration date'),
  ]

  const actionsColumn: ColumnDef<ManageUserTableRow> = {
    id: 'actions',
    size: 80,
    header: () => h('span', { class: 'capitalize text-sm text-slate-800 font-semibold' }, 'actions'),
    cell: ({ row }) => {
      const invitationId = row.original.invitation_id
      const tooltipClasses = 'absolute hidden group-hover:block bottom-full left-1/2 transform -translate-x-1/2 px-2 py-1 bg-zuno-primary-2 text-white text-xs rounded whitespace-nowrap mb-1 z-10'

      const handleResendInvitation = () => {
        if (invitationId) {
          actions?.onResendInvitation?.(invitationId)
        }
      }

      const handleRevokeInvitation = () => {
        if (invitationId) {
          actions?.onRevokeInvitation?.(invitationId)
        }
      }

      return h('div', { class: 'flex' }, [
        h('div', {
          class: 'relative group',
        }, [
          h(BaseButton, {
            variant: 'text',
            onClick: handleResendInvitation,
          }, () => h(ResendInvitationIcon)),
          h('div', {
            class: tooltipClasses,
          }, 'Resend Invite'),
        ]),
        h('div', {
          class: 'relative group',
        }, [
          h(BaseButton, {
            variant: 'text',
            onClick: handleRevokeInvitation,
          }, () => h(TrashGreenIcon)),
          h('div', {
            class: tooltipClasses,
          }, 'Revoke Invite'),
        ]),
      ])
    },
  }

  return [
    ...baseColumns,
    ...dateColumns,
    actionsColumn,
  ]
}
